import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetMedicalRepresentativeList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/MedicalRepresentative/GetList?` + params, null);
  
export const GetMedicalRepresentativeDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/MedicalRepresentative/GetDetail?` + params, null);

export const CreateMedicalRepresentative = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicalRepresentative/Create`, data);

export const UpdateMedicalRepresentative = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicalRepresentative/Update`, data);    

export const DeleteMedicalRepresentative = (data: any) =>
  POST_ENC(`${BASE_URL}/api/MedicalRepresentative/Delete`, data);

export const GetMedicalRepresentativeNumber = (params: any) =>
  GET_ENC(`${BASE_URL}/api/MedicalRepresentative/GetMedicalRepresentativeNumber?` + params, null);
